import React from 'react';
import CommissionLineAdmin from './CommissionLineAdmin';
import TabbedPage from '../../../Elements/TabbedPage';
import CommissionLineDetailAdmin from './CommissionLineDetailAdmin';

export default class CommissionLineParentAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 0,
      commissionedUserId: null,
      commissionedExternalSalesPartnerId: null,
      clientId: null,
      opportunityId: null,
      serviceId: null,
    };
  }

  componentDidMount() {}

  changeTab(tab, commissionedUserId, commissionedExternalSalesPartnerId, clientId, opportunityId, serviceId) {
    this.setState({ tab, commissionedUserId, commissionedExternalSalesPartnerId, clientId, opportunityId, serviceId });
  }

  render() {
    const tabs = [
      {
        label: 'Commission Line',
        id: 'commissionline',
        icon: 'fa-solid fa-hand-holding-dollar',
        component: <CommissionLineAdmin changeTab={this.changeTab.bind(this)} />,
      },
      {
        label: 'Commission Line Detail',
        id: 'commissionlinedetail',
        icon: 'fa-solid fa-magnifying-glass-dollar',
        component: (
          <CommissionLineDetailAdmin
            selectedUserId={this.state.commissionedUserId}
            selectedExternalSalesPartnerId={this.state.commissionedExternalSalesPartnerId}
            clientId={this.state.clientId}
            opportunityId={this.state.opportunityId}
            serviceId={this.state.serviceId}
          />
        ),
      },
    ];

    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={tabs}
              openOnTab={this.state.tab}
              onTabChange={this.changeTab.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}
